function attachClickEventHandler(
  doc: Document,
  elementsClass: string,
  onClickHandler: EventListener | EventListenerObject
) {
  const cbOptOutLinkElements = doc.getElementsByClassName(elementsClass)
  if (cbOptOutLinkElements.length < 1) {
    return
  }
  for (const elem of Array.from(cbOptOutLinkElements)) {
    /*                                                  */
    elem.removeEventListener('click', onClickHandler)
    elem.addEventListener('click', onClickHandler)
  }
}

/**
 *
 *
 *
 *
 *
 *
 */
export function attachMutationSafeClickHandler(
  elementsClass: string,
  onClickHandler: EventListenerOrEventListenerObject,
  doc: Document = document
): MutationObserver {
  /*                                 */
  attachClickEventHandler(doc, elementsClass, onClickHandler)

  /*                                                                            */
  const mutationObserver = new MutationObserver((mutationsList) => {
    if (!mutationsList.some((mutation) => mutation.type === 'childList')) {
      return
    }
    attachClickEventHandler(doc, elementsClass, onClickHandler)
  })
  mutationObserver.observe(document.body, { childList: true, subtree: true })
  return mutationObserver
}
